/**
 * Canonical Render Contracts
 * Authority: SCHEMA AGENT (Stability V2)
 * Purpose: Guarantee "Render-Safe" data shapes for all UI components.
 */

export const FounderRenderContract = {
    id: "",
    display_name: "Unknown Founder",
    subtitle: "Individual", // Usually startup_name
    email: "—",
    contact_status: "Unassigned",
    email_status: "Valid",
    last_contact_label: "Never",
    avatar_initial: "?"
};

export const InvestorRenderContract = {
    id: "",
    display_name: "Unknown Fund",
    subtitle: "Investor", // Usually type
    geo_label: "—",
    sectors: [], // Guaranteed array
    avatar_initial: "?"
};

export const StartupRenderContract = {
    id: "",
    display_name: "Untitled Startup",
    subtitle: "Uncategorized", // Usually sector
    stage_label: "—",
    status_key: "unassigned",
    last_contact_label: "—",
    avatar_initial: "?"
};

export const KBItemRenderContract = {
    id: "",
    display_name: "Untitled Entry",
    summary: "No summary available.",
    score: 0,
    recommendation: "NONE",
    date_label: "—",
    status_label: "Pending"
};

/**
 * Work Item Contract
 * Authority: WORK_SURFACE_DATA_CONTRACT.md
 * Purpose: Defines the shape of any actionable item in the Work/Inbox Surface.
 */
export const WorkItemRenderContract = {
    id: "",
    type: "review_generic", // startup | kb | campaign | review_generic
    title: "Untitled Item", // noscan
    description: "No description provided.", // noscan
    priority: "Normal", // High | Normal
    status: "pending",
    timestamp: null,
    // Campaign Specifics (Optional/Conditional)
    preview: { subject: "No Preview", html_body: "<p>No Preview Available</p>" },
    recipients: []
};


/**
 * Contract Defaults Generator
 * Returns a fresh default object for the given contract type.
 */
export const getContractDefaults = (type) => {
    switch (type) {
        case 'Founder': return { ...FounderRenderContract };
        case 'Investor': return { ...InvestorRenderContract };
        case 'Startup': return { ...StartupRenderContract };
        case 'KBItem': return { ...KBItemRenderContract };
        case 'WorkItem': return { ...WorkItemRenderContract };
        default: return {};
    }
};
